const eventSteps = [
  { key: "emailSentAt", label: "Sent", status: "sent" },
  { key: "emailDeliveredAt", label: "Delivered", status: "delivered" },
  { key: "emailOpenedAt", label: "Opened", status: "opened" },
  { key: "emailClickedAt", label: "Viewed", status: "clicked" },
];

const issueSteps = [
  { key: "emailDeliveryDelayedAt", label: "Delivery delayed", status: "delayed" },
  { key: "emailBouncedAt", label: "Bounced", status: "bounced" },
  { key: "emailFailedAt", label: "Failed", status: "failed" },
  { key: "emailComplainedAt", label: "Spam complaint", status: "complained" },
  { key: "emailSuppressedAt", label: "Suppressed", status: "suppressed" },
];

function formatEventDate(value) {
  if (!value) {
    return "";
  }

  return new Date(value).toLocaleString([], {
    day: "numeric",
    month: "short",
    year: "numeric",
    hour: "numeric",
    minute: "2-digit",
  });
}

function latestDeliveryLabel(invoice) {
  const statusLabels = {
    received: "Received",
    scheduled: "Scheduled",
    sent: "Sent",
    delivered: "Delivered",
    delivery_delayed: "Delivery delayed",
    opened: "Opened",
    clicked: "Viewed",
    bounced: "Bounced",
    failed: "Failed",
    complained: "Spam complaint",
    suppressed: "Suppressed",
  };

  if (invoice?.emailStatus && statusLabels[invoice.emailStatus]) {
    return statusLabels[invoice.emailStatus];
  }

  const latestEvent = [...eventSteps].reverse().find((step) => invoice?.[step.key]);

  if (latestEvent) {
    return latestEvent.label;
  }

  if (invoice?.emailStatus) {
    return invoice.emailStatus.replaceAll("_", " ");
  }

  return invoice?.status || "Draft";
}

function DeliveryStep({ step, value, compact = false }) {
  if (!value && compact) {
    return null;
  }

  return (
    <div className={`invoice-delivery-step ${value ? "complete" : ""} status-${step.status}`}>
      <span className="invoice-delivery-dot" />
      <div>
        <strong>{step.label}</strong>
        {value && <small>{formatEventDate(value)}</small>}
      </div>
    </div>
  );
}

export default function InvoiceDeliveryStatus({ invoice, compact = false }) {
  if (!invoice) {
    return null;
  }

  if (compact) {
    return <span className={`invoice-delivery-pill ${latestDeliveryLabel(invoice).toLowerCase().replaceAll(" ", "-")}`}>{latestDeliveryLabel(invoice)}</span>;
  }

  const visibleIssues = issueSteps.filter((step) => invoice[step.key]);

  return (
    <section className="invoice-delivery-status">
      <h3>Email Delivery</h3>
      <div className="invoice-delivery-grid">
        {eventSteps.map((step) => (
          <DeliveryStep key={step.key} step={step} value={invoice[step.key]} />
        ))}
      </div>
      {visibleIssues.length > 0 && (
        <div className="invoice-delivery-issues">
          {visibleIssues.map((step) => (
            <DeliveryStep key={step.key} step={step} value={invoice[step.key]} compact />
          ))}
        </div>
      )}
    </section>
  );
}
